import clsx from "clsx";
import { IconProps } from "@/types";
import { createColorClasses } from "@/theme/colors";

export const ArrowLeft = ({
  width = 24,
  height = 24,
  className,
  color,
  onClick,
  decorative = false,
  ariaLabel = "Left arrow",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="currentColor"
        d="M14.4 17.6 8.8 12l5.6-5.6.8.7-4.9 4.9 4.9 4.9z"
      ></path>
    </svg>
  );
};
